<template lang="pug">
v-content
  v-container.fill-height(fluid="")
    v-row(align="center", justify="center")
      v-col(cols="12", sm="8", md="6")
        v-card.elevation-12
          v-toolbar(color="primary", dark, flat)
            v-toolbar-title Recuperación Contraseña
          .alert(v-if="messages_error_request")
            v-alert(border="top", color="red lighten-2", dark)
              ul
                li(v-for="message in messages_error_request") {{ message }}
          v-card-text
            ValidationObserver(ref="observer", v-slot="{ validate, reset }")
              v-form
                ValidationProvider(
                  v-slot="{ errors }",
                  name="Contraseña",
                  rules="required|min:8"
                )
                  v-text-field(
                    label="Contraseña",
                    prepend-icon="fa-lock",
                    v-model="password",
                    :type="show_password ? 'text' : 'password'",
                    :append-icon="show_password ? 'fa-eye' : 'fa-eye-slash'",
                    @click:append="show_password = !show_password",
                    :error-messages="errors",
                    required
                  )
                ValidationProvider(
                  v-slot="{ errors }",
                  name="Contraseña",
                  rules="required|min:8"
                )
                  v-text-field(
                    label="Confrimación Contraseña",
                    prepend-icon="fa-lock",
                    v-model="password_conf",
                    :type="show_password_conf ? 'text' : 'password'",
                    :append-icon="show_password_conf ? 'fa-eye' : 'fa-eye-slash'",
                    @click:append="show_password_conf = !show_password_conf",
                    :error-messages="errors",
                    required
                  )
            v-card-actions
              v-spacer
              v-btn(
                color="primary",
                @click="recovery_password",
                :loading="loading",
                :disabled="loading",
                outlined,
                block
              ) Recuperar
</template>

<script>
import authAPI from "@/api/auth";
import { required, email, min } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío",
});

extend("min", {
  ...min,
  message: "{_field_} no puede ser menor que {length} caracteres",
});

extend("email", {
  ...email,
  message: "Correo Electrónico debe ser válido",
});

export default {
  name: "Recovery",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      password: null,
      password_conf: null,
      show_password: false,
      show_password_conf: false,
      messages_error_request: null,
    };
  },
  methods: {
    async recovery_password() {
      this.messages_error_request = null;
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        const response = await authAPI.recoveryPassword({
          new_password: this.password,
          token: this.$route.params.token,
          new_password_confirmation: this.password_conf,
        });
        this.loading = false;
        if (response.status) {
          this.$swal({
            title: "Tu contraseña se ha recuperado exitosamente",
            icon: "success",
          }).then(async (_) => {
            this.$router.replace("/auth/login");
          });
        } else {
          this.messages_error_request = response.data;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>

